import { render } from "./LegendaTipoDocumentoRelatorioPsicologico.vue?vue&type=template&id=243d4790"
const script = {}

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__